module.exports = __webpack_public_path__ + "fwd_logo.2Q6V4.png";